import store from "@/store/index";

export function getSetting(settingKey: string) : any {
    return store.getters["authentication/getUserAutoSettings"][settingKey];
}

export async function setSetting(settingKey: string, value: any) {
    store.getters["authentication/getUserAutoSettings"][settingKey] = value;
    await store.dispatch("authentication/updateUserAutoSettings",
        store.getters["authentication/getUserAutoSettings"]);
}
